// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const actionGQLFields = (fields) => {
    return `
    status
  `;
};
//# sourceMappingURL=action.fields.js.map